<template>
  <div class="table_wrapper mt-5">
    <h2 class="section-title text-center mt-5">{{ $t("landing.companytable.title") }}</h2>
    <table class="table tablebox">
      <thead>
        <tr>
          <th scope="col">{{ $t("landing.companytable.th1") }}</th>
          <th scope="col">{{ $t("landing.companytable.th2") }}</th>
          <th scope="col">{{ $t("landing.companytable.th3") }}</th>
          <th class="mobilehidden" scope="col">{{ $t("landing.companytable.th4") }}</th>
          <th class="mobilehidden2" scope="col">{{ $t("landing.companytable.th5") }}</th>
          <th class="mobilehidden2" scope="col">{{ $t("landing.companytable.th6") }}</th>
        </tr>
      </thead>
      <tbody>
        <tr class="nobottom" v-for="(lead, idx) in leads">
          <th scope="row">
            <img class="logo-size" :src="lead.logo" alt="fakelogo" />
            {{ lead.company }}
          </th>
          <td>{{ lead.industry }}</td>
          <td>{{ lead.location }}</td>
          <td class="mobilehidden">{{ lead.role }}</td>
          <td class="mobilehidden2">
            <d-button
              class="mobilehidden2 icon-yellow btn-white ml-2"
              v-d-tooltip.hover="$t('company.tooltipwebsite')"
            >
              <i class="icon-yellow material-icons">link</i>
            </d-button>
          </td>
          <td class="mobilehidden2">
            <button class="btn btn-primary mobilehidden2">{{ $t("landing.companytable.button") }}</button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  data() {
    return {
      leads: [
        {
          logo: require("@/assets/images/fakecompanies/c1.png"),
          company: "HextGen",
          industry: "Software",
          role: "CEO",
          location: "San Francisco, CA"
        },
        {
          logo: require("@/assets/images/fakecompanies/c2.png"),
          company: "AlphaCode",
          industry: "Software",
          role: "CMO",
          location: "Santa Clara, CA"
        },
        {
          logo: require("@/assets/images/fakecompanies/c3.png"),
          company: "ByteSize",
          industry: "Software",
          role: "Dev Lead",
          location: "San Jose, CA"
        },
        {
          logo: require("@/assets/images/fakecompanies/c4.png"),
          company: "GenX",
          industry: "Software",
          role: "Sales",
          location: "Pacifica, CA"
        }
      ]
    };
  }
};
</script>

<style lang="scss" scoped>
@media (max-width: 767px) {
  .mobilehidden {
    display: none;
  }
}

.nobottom {
  &:last-child {
    border-bottom: none !important;
  }
}

tr {
  border-bottom: 1px solid #dee2e6 !important;
}

th {
  border: none !important;
}

.section-title {
  color: #222;
  text-align: center;
  font-size: 3.0625rem;
  font-weight: 600;
  line-height: 4.1rem;
  font-family: "Source Sans Pro", -apple-system, BlinkMacSystemFont, sans-serif !important;
}

@media (max-width: 564px) {
  .mobilehidden2 {
    display: none;
  }
}

@media (max-width: 767px) {
  .section-title {
    transition: all 0.4s ease-in-out;
    font-family: "Source Sans Pro", -apple-system, BlinkMacSystemFont,
      sans-serif !important;
  }

  .section-title {
    font-size: 45px !important;
    line-height: 45px;
    text-align: center !important;
  }
}

.tablebox {
  border-radius: 8px;
  margin-top: 3rem;
  box-sizing: border-box;
  overflow: hidden;
  padding: 0.6rem;
  box-shadow: 0px 0.125rem 0.625rem rgba(#959ba3, 0.2);
}

.table_wrapper {
  margin: 0 auto;
  bottom: 0px;
  box-sizing: border-box;
  left: 0px;
  position: relative;
  right: 0px;
  text-size-adjust: 100%;
  top: 0px;
  width: 1039.88px;
  perspective-origin: 519.938px 255.375px;
  transform-origin: 519.938px 255.375px;
  background: rgb(255, 255, 255) none repeat scroll 0% 0% / auto padding-box
    border-box;
  border-radius: 5px;
  font: normal normal 400 normal 16px / 18.4px "Avenir Next", sans-serif;
  overflow: hidden;
  padding: 0px 10px 10px;
}

.logo-size {
  width: 35px;
  margin-right: 0.8rem;
}
.th {
  color: #959ba3 !important;
}
</style>